<template>
  <b-row>
    <b-col>
      <Loader v-if="loading"></Loader>
      <section v-else>
        <span><b>{{$t('views.userdata.show.groupName')}}</b>: {{groupInfo.name}}</span><br>
        <span><b>{{$t('views.excmmessages.list.createdAt')}}</b>: {{groupInfo.date_created}}</span><br>
        <span><b>{{$t('views.excmmessages.list.modifiedAt')}}</b>: {{groupInfo.date_updated}}</span><br>
        <span><b>{{$t('views.userdata.show.inGroupsMembersTotal')}}</b>: {{groupInfo.total}}</span><br>
        <span><b>{{$t('views.userdata.show.inGroupsMembersActive')}}</b>: {{groupInfo.active}}</span><br>
        <span><b>{{$t('views.userdata.show.mailerLiteSent')}}</b>: {{groupInfo.sent}}</span><br>
        <span><b>{{$t('views.userdata.show.mailerLiteOpened')}}</b>: {{groupInfo.opened}}</span><br>
        <span><b>{{$t('views.userdata.show.mailerLiteClicked')}}</b>: {{groupInfo.clicked}}</span>
        <section v-if="groupInfo.subscribers.length > 0">
          <br>
          <span><b>{{$t('views.userdata.show.emailsInGroup')}}</b>:</span>
          <ul>
            <li v-for="(item, key) in groupInfo.subscribers" v-bind:key="key">{{item.email}}</li>
          </ul>
        </section>
      </section>
    </b-col>
  </b-row>
</template>
<script>
import Loader from '@/components/Dashboard/Layout/Loader'
import ApiService from '@/utils/ApiService'

export default {
  name: 'mailerLiteGroupInfo',
  components: { Loader },
  created () {
    this.fetchMailerLiteGroupInfo()
  },
  data () {
    return {
      loading: true,
      groupInfo: {}
    }
  },
  props: ['idGroup'],
  methods: {
    async fetchMailerLiteGroupInfo () {
      this.groupInfo = await new ApiService('mailerlitegroup/' + this.idGroup).getResults()
      this.loading = false
    }
  }
}
</script>
